export default __webpack_public_path__ + "static/media/fpx.2880c6f7.svg";